import React from "react";
import BaseComponent from '../BaseComponent';

import BannerPath from 'images/green-bg-plain.jpg';

class AboutBanner extends BaseComponent {
  render() {
    var bgStyle = {
      background: `url(${BannerPath}) no-repeat center center`,
      backgroundSize: 'cover'
    }
    return (
      <>
        <div className="banner hide-overflow-x" style={bgStyle}>
          <div className="container text-white">
            <div className="" style={{ marginTop: '15rem', height: '350px' }}>
            </div>
          </div>
        </div>
        <div className="container text-white hide-overflow-x mb-5 pb-5" style={{ marginTop: '-350px' }}>
          <div className="row justify-content-center" style={{ textAlign: 'center', paddingTop: '50px' }}>
            <div className='col-xs-10 col-sm-10 col-md-10 col-lg-8 col-xl-8'>
              <div className="mb-3 about-us" data-aos="fade-up">
                About Us
              </div>
              <h1 className="gw-largetitle mb-5" data-aos="fade-up">
                Pioneering needle-free<br/>disease monitoring
              </h1>
            </div>
          </div>
          <div className="pb-5 mb-5" style={{ height: '150px' }}></div>
        </div>
      </>
    );
  }
}

export default AboutBanner
